import React, { useState } from "react";
import "../../css/SafetySecurity.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const STATS = [
  { number: "24x7", label: "Guarded Entry Points" },
  { number: "300+", label: "Access Control Points" },
  { number: "150+", label: "Facial Recognition Systems" },
  { number: "600+", label: "CCTV Cameras" },
];

const FAQ_ITEMS = [
  {
    q: "What security measures does Sahara Public School have in place?",
    a: "From guarded entry points and biometric access to facial recognition and CCTV monitoring, we maintain multiple layers of security across the campus at all times.",
  },
  {
    q: "How does the school verify who enters the campus?",
    a: "Every gate uses identification-based access control, with authorised staff and students verified through smart ID cards and biometric checks before entry.",
  },
  {
    q: "Are classrooms monitored as well?",
    a: "Yes, CCTV cameras and facial recognition systems are present inside classrooms too, giving parents added assurance about their child's safety throughout the day.",
  },
];

export default function SafetySecurity() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="ss-page">
      {}
      <SchoolHero
        title="Safety & Security"
        subtitle="World-Class Infrastructure"
        image="/images/sa.jpeg"
      />
      <section className="ss-hero">
        <h1>Safety & Security</h1>
        <p>
          Running a large, busy campus is a big responsibility — one we take
          seriously at every step, from entry to exit.
        </p>
      </section>

      {}
      <section className="wrap ss-intro">
        <p>
          Sahara Public School has put in place multiple layers of security to
          keep students and teachers protected from the moment they enter the
          campus to the time they leave.
        </p>
        <p>
          Each layer combines traditional practices with modern technology,
          designed thoughtfully to give parents complete peace of mind.
        </p>
      </section>

      {}
      <section className="wrap ss-layer">
        <div className="ss-layer-icon">
          <span className="emoji-badge">🚧</span>
        </div>
        <div>
          <h2>Secured Entry & Exits</h2>
          <p>
            A guard house keeps watch 24x7 at the gates, regulating the entry
            and flow of visitors into the campus.
          </p>
          <p>
            Biometric-enabled access points are installed at all gates, allowing
            entry only to authorised staff and students carrying proper
            identification. This ensures every gate stays monitored at all
            times.
          </p>
        </div>
      </section>

      {}
      <section className="wrap ss-layer reverse">
        <div>
          <h2>Facial Recognition</h2>
          <p>
            Designed with student safety at its core, our facial recognition
            system allows students to mark attendance seamlessly while keeping
            track of their movement within the campus.
          </p>
          <p>
            It also secures classroom doors, ensuring only recognised students
            and staff can enter — effectively acting as a smart locking system
            for every classroom.
          </p>
        </div>
        <div className="ss-layer-icon">
          <span className="emoji-badge">🔎</span>
        </div>
      </section>

      {}
      <section className="wrap ss-layer">
        <div className="ss-layer-icon">
          <span className="emoji-badge">🪪</span>
        </div>
        <div>
          <h2>Smart Identification Cards</h2>
          <p>
            Every student and staff member carries a smart ID card combining
            biometric and facial recognition technology for a safe, seamless
            experience.
          </p>
          <p>
            These cards support daily attendance, access to special studios, and
            cashless payments at campus cafeterias — all backed by a secure,
            verified digital identity.
          </p>
        </div>
      </section>

      {}
      <section className="wrap ss-layer reverse">
        <div>
          <h2>Closed-Circuit Security Cameras</h2>
          <p>
            CCTV cameras are deployed across the campus, including every entry
            and exit point, monitoring movement around the clock.
          </p>
          <p>
            Cameras are also present inside classrooms, giving students a sense
            of security and giving parents confidence that all campus activity
            is being watched over.
          </p>
        </div>
        <div className="ss-layer-icon">
          <span className="emoji-badge">📹</span>
        </div>
      </section>

      {}
      <section className="ss-stats">
        <div className="wrap ss-stats-grid">
          {STATS.map((s) => (
            <div key={s.label}>
              <div className="ss-stat-number">{s.number}</div>
              <div className="ss-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {}
      <section className="wrap ss-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
  );
}
